<app-button-group>
  <button buttonType="flat" buttonTheme="light" app-button [selected]="(viewMode$ | async) === galleryViewMode.Cards" (click)="handleViewModeClick(galleryViewMode.Cards)">
      <fa-icon icon="th"></fa-icon>
  </button>
  
  <button buttonType="flat" buttonTheme="light" app-button [selected]="(viewMode$ | async) === galleryViewMode.List" (click)="handleViewModeClick(galleryViewMode.List)">
      <fa-icon icon="bars"></fa-icon>
  </button>
  
</app-button-group>